export type T_dataComponent = "POSTCARD" | "FULL_PAGE" | "WEBSITE" | "HOME";

export function typeToClass(type: T_dataComponent) {
  if (type === "POSTCARD") return "-postcard";
  else if (type === "FULL_PAGE") return "-full";
  else return "";
}
